(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-logos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brand-logos-desktop-slider')) {
    customElements.define('brand-logos-desktop-slider', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        this.track = this.querySelector('.brand-logos__items');
        this.slides = Array.from(this.track?.children || []);
        this.controls = this.querySelector('.brand-logos__slider-controls');
        this.previous = this.querySelector('[data-slider-prev]');
        this.next = this.querySelector('[data-slider-next]');
        if (!this.track || !this.controls || !this.previous || !this.next) return;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.desktop = matchMedia('(min-width: 768px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.scheduleUpdate = () => {
          cancelAnimationFrame(this.updateFrame);
          this.updateFrame = requestAnimationFrame(() => this.update());
        };

        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', this.scheduleUpdate, { ...options, passive: true });
        this.desktop.addEventListener('change', this.scheduleUpdate, options);
        this.track.addEventListener('keydown', (event) => {
          if (!this.desktop.matches || event.target !== this.track) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.scrollToPosition(event.key === 'Home' ? 0 : this.track.scrollWidth);
          }
        }, options);

        document.addEventListener('shopify:block:select', (event) => {
          if (!this.desktop.matches) return;
          const slide = this.slides.find((item) => item.dataset.blockId === event.detail?.blockId);
          if (!slide) return;
          const firstRect = this.slides[0].getBoundingClientRect();
          const slideRect = slide.getBoundingClientRect();
          this.scrollToPosition(Math.abs(slideRect.left - firstRect.left), 'instant');
        }, options);

        this.observer = new ResizeObserver(this.scheduleUpdate);
        this.observer.observe(this.track);
        this.slides.forEach((slide) => this.observer.observe(slide));
        this.setAttribute('data-slider-ready', '');
        this.update();
      }

      update() {
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const active = this.desktop.matches && maximum > 2;
        const position = Math.abs(this.track.scrollLeft);
        this.controls.hidden = !active;
        this.previous.disabled = !active || position <= 2;
        this.next.disabled = !active || position >= maximum - 2;
        if (active) {
          this.track.setAttribute('tabindex', '0');
        } else {
          this.track.removeAttribute('tabindex');
        }
      }

      move(direction) {
        if (!this.desktop.matches || !this.slides.length) return;
        const first = this.slides[0].getBoundingClientRect();
        const second = this.slides[1]?.getBoundingClientRect();
        const step = second ? Math.abs(second.left - first.left) : first.width;
        this.scrollToPosition(Math.abs(this.track.scrollLeft) + direction * step);
      }

      scrollToPosition(position, behavior) {
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollTo({
          left: Math.min(maximum, Math.max(0, position)) * (rtl ? -1 : 1),
          behavior: behavior || (this.reducedMotion.matches ? 'instant' : 'smooth')
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.updateFrame);
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
